import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import GetData from "./services/getData";
import "./Auth.css";

function Auth({ onSuccess }) {
  const { t } = useTranslation("auth");
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [retryAfterSeconds, setRetryAfterSeconds] = useState(0);

  useEffect(() => {
    if (retryAfterSeconds <= 0) return undefined;
    const t = setInterval(() => {
      setRetryAfterSeconds((s) => (s <= 1 ? 0 : s - 1));
    }, 1000);
    return () => clearInterval(t);
  }, [retryAfterSeconds]);

  const normalizePhone = (v) => v.replace(/\D/g, "");

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setRetryAfterSeconds(0);
    const normalized = normalizePhone(phone);
    if (normalized.length < 10) {
      setError(t("errors.phone"));
      return;
    }
    if (!password) {
      setError(t("errors.password"));
      return;
    }
    setLoading(true);
    try {
      const result = await GetData({
        module: "auth",
        block: "auth",
        action: "login",
        phone: normalized,
        password,
      });
      // Токен сохраняется сервером в HttpOnly cookie
      if (result && result.result === "Y") {
        if (onSuccess) onSuccess();
        return;
      }
      setError(result?.message || t("errors.loginFailed"));
      const wait = Number(result?.retry_after_seconds);
      if (Number.isFinite(wait) && wait > 0) {
        setRetryAfterSeconds(Math.ceil(wait));
      }
    } catch (err) {
      setError(err?.message || t("errors.authError"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-screen">
      <div className="auth-box">
        <h2 className="auth-title">{t("title")}</h2>
        {error && (
          <div className="auth-error">
            {error}
            {retryAfterSeconds > 0 ? (
              <span className="auth-retry-hint">{" "}{t("retryHint", { seconds: retryAfterSeconds })}</span>
            ) : null}
          </div>
        )}

        <form onSubmit={handleLogin} className="auth-form">
          <label className="auth-label">{t("phone")}</label>
          <input
            type="tel"
            className="auth-input"
            placeholder={t("phonePlaceholder")}
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            disabled={loading}
            autoComplete="tel"
          />
          <label className="auth-label">{t("password")}</label>
          <input
            type="password"
            className="auth-input"
            placeholder={t("passwordPlaceholder")}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            disabled={loading}
            autoComplete="current-password"
          />
          <button
            type="submit"
            className="auth-submit"
            disabled={loading || retryAfterSeconds > 0}
          >
            {loading
              ? t("submitting")
              : retryAfterSeconds > 0
                ? t("wait", { seconds: retryAfterSeconds })
                : t("submit")}
          </button>
        </form>
      </div>
    </div>
  );
}

export default Auth;
